import '../../styles/flag.css';
import '../../styles/flags/xmk.css';


export default function FlagXMK()
{
    let columns = [];
    for (let x = 0; x < 30; x++) {
        columns.push(x);
    }

    return (
        <div className="flag flag-xmk">
            {columns.map((columnIndex) => (
                <div
                    key={columnIndex}
                    className="flag-column"
                    style={{
                        animationDelay: columnIndex * 100 + 'ms',
                        backgroundPositionX: '-' + columnIndex + 'px'
                    }}
                />
            ))}
        </div>
    );
}
